import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginFormControls } from '../entities/login-form';
import { PW_MIN_LENGTH } from '../constants/common';

@Injectable()
export class LoginFormService {
    private _form: FormGroup = new FormGroup({});

    get form(): FormGroup {
        return this._form;
    }

    initForm(): void {
        this._form = new FormGroup({
            [LoginFormControls.EMAIL]: new FormControl('', {
                validators: [Validators.required, Validators.email],
                updateOn: 'blur'
            }),
            [LoginFormControls.PASSWORD]: new FormControl('', {
                validators: [Validators.required, Validators.minLength(PW_MIN_LENGTH)],
                updateOn: 'blur'
            })
        });
    }

    validateForm(): void {
        Object.values(this.form.controls).forEach(this.markForValidation);
        this.markForValidation(this.form);
    }

    private markForValidation(control: AbstractControl) {
        control.markAsDirty();
        control.markAsTouched();
        control.updateValueAndValidity();
    }
}
